export default "<app-global-confirmation [mainTitle]=\"mainTitle\" [message]=\"message\"></app-global-confirmation>\n"